import { useState, useEffect } from 'react';
import { Box, Button, Paper, Typography, Slide } from '@mui/material';

const PwaInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setIsInstalled(true);
      return;
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowPrompt(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      setIsInstalled(true);
    }
    setDeferredPrompt(null);
    setShowPrompt(false);
  };

  const handleDismiss = () => {
    setShowPrompt(false);
    localStorage.setItem('pwa-dismissed', Date.now().toString());
  };

  const dismissedRecently = localStorage.getItem('pwa-dismissed');
  if (dismissedRecently && (Date.now() - parseInt(dismissedRecently)) < 86400000) return null;
  if (isInstalled || !showPrompt) return null;

  return (
    <Slide direction="up" in={showPrompt}>
      <Paper
        elevation={8}
        sx={{
          position: 'fixed', bottom: 16, left: 16, right: 16, maxWidth: 400, mx: 'auto',
          zIndex: 9999, p: 2, borderRadius: 3, background: 'linear-gradient(135deg, #1a1a2e, #16213e)',
          border: '1px solid rgba(255,255,255,0.08)',
        }}
      >
        <Box display="flex" alignItems="center" gap={2}>
          <img src="/assets/logo.png" alt="Uben" style={{ width: 48, height: 48, borderRadius: 12 }} />
          <Box flex={1}>
            <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 0.5 }}>
              Install Uben
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Quick access from your home screen
            </Typography>
          </Box>
        </Box>
        <Box display="flex" gap={1} mt={2}>
          <Button fullWidth variant="outlined" size="small" onClick={handleDismiss}>
            Not now
          </Button>
          <Button fullWidth variant="contained" size="small" onClick={handleInstall}>
            Install
          </Button>
        </Box>
      </Paper>
    </Slide>
  );
};

export default PwaInstallPrompt;
